"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var booking_const_1 = require("./booking.const");
/**
 * BookingService
 * @class
 */
var BookingService = /** @class */ (function () {
    function BookingService() {
    }
    /**
     * Returns bookings of a given profile (`user_profile_uuid`),
     * @param userProfileUuid {string}
     * @returns
     */
    BookingService.prototype.getIndex = function (userProfileUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.getIndex
            .replace('{{version}}', version)
            .replace('{{userProfileUuid}}', userProfileUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a details of a given booking (`bookingUuid`),
     * @param bookingUuid {string}
     * @returns
     */
    BookingService.prototype.getBooking = function (bookingUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.getBooking
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a filtered booking's Summary,
     * @param params<SummaryParams>
     * `{{start}}` = `params.from`
     * `{{end}}`= `params.to`
     * `{{location_uuid}}`= `params.location`
     * `{{vehicle_uuid}}`= `params.vehicle`
     * `{{user_profile_uuid}}`= `params.profile`
     * `{{user_uuid}}` = `params.user`
     * @returns
     */
    BookingService.prototype.getBookingSummary = function (params, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.getBookingSummary
            .replace('{{version}}', version)
            .replace('{{start}}', params.from)
            .replace('{{end}}', params.to)
            .replace('{{locationUuid}}', params.location)
            .replace('{{vehicleUuid}}', params.vehicle)
            .replace('{{userProfileUuid}}', params.profile)
            .replace('{{userUuid}}', params.user);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a details of an insurance attached to a given booking (`bookingUuid`),
     * @param bookingUuid {string}
     * @returns
     */
    BookingService.prototype.getUpgradeInsuranceInfo = function (bookingUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.getUpgradeInsuranceInfo
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns an a given booking's availability info (`bookingUuid`),
     * @param bookingUuid {string}
     * @returns
     */
    BookingService.prototype.getUpdateAvailabilityInfo = function (bookingUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.getUpdateAvailabilityInfo
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a filtered, updated booking CostParams,
     * @param params<CostParams>
     * `{{bookingUuid}}` = `params.from`
     * `{{userUuid}}` = `params.user`
     * `{{start}}`= `params.from`
     * `{{end}}`= `params.to`
     * @returns
     */
    BookingService.prototype.getUpdatedCostInfo = function (params, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.getUpdatedCostInfo
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', params.booking)
            .replace('{{userUuid}}', params.user)
            .replace('{{start}}', params.from)
            .replace('{{newEnd}}', params.to);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns an a given booking's Cancel Fees info (`bookingUuid`),
     * @param bookingUuid {string}
     * @returns
     */
    BookingService.prototype.getBookingCancelFees = function (bookingUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.getBookingCancelFees
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Adds an a new booking
     * @param data<Booking>
     * @returns
     */
    BookingService.prototype.postBooking = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.postBooking.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Adds an a new booking
     * @param bookingUuid {string}
     * @param data Partial<Booking>
     * @returns
     */
    BookingService.prototype.putUpdateBooking = function (bookingUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.putUpdateBooking
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Cancels booking
     * @param bookingUuid {string
     * @param data Partial<Booking>
     * @returns
     */
    BookingService.prototype.putCancelBooking = function (bookingUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.putCancelBooking
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Updates booking insurance info
     * @param bookingUuid {string}
     * @param data Partial<Booking>
     * @returns
     */
    BookingService.prototype.putUpdateInsurance = function (bookingUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.putUpdateInsurance
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Add/update the list of additional drivers for a booking
     * @param bookingUuid {string}
     * @param emails Emails
     * @param version
     * @returns
     */
    BookingService.prototype.postAdditionalDrivers = function (bookingUuid, emails, version) {
        if (version === void 0) { version = 'v1'; }
        var url = booking_const_1.BOOKING_ENDPOINT.postAdditionalDrivers
            .replace('{{version}}', version)
            .replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.post(url, emails);
    };
    return BookingService;
}());
/**
 * External BookingService Class Instance
 * @namespace
 */
exports.booking = new BookingService();
